import { Model } from "@vuex-orm/core";

import { technicianEntity } from "./technician-entity";
import { DateTime } from "luxon";
import { getBrowserIanaTimeZone as localTz } from "../../helper/browser-time-zone";
import { emailConfigurationEntity } from "./email-configuration-list-entity";

export interface technicianGroupEntity {
  technicianGroupId: number;
  name: string;
  isActive: boolean;
  isDefault: boolean;
  description: string;
  alias: string;
  serviceProviderId: number;
  tick: number;
  createdOn: string;
  createdById: number;
  updatedOn: string;
  updatedById: number;
  isFilling: boolean;
  emailConfigurationId: number;
  sendNotificationToSuperUser: boolean;
}

export class technicianGroupEntity extends Model {
  static entity = "technicianGroupEntity";
  static primaryKey = "technicianGroupId";
  static fields() {
    return {
      technicianGroupId: this.number(0),
      name: this.string(null),
      isActive: this.boolean(null),
      isDefault: this.boolean(false),
      description: this.string(null),
      alias: this.attr(null),
      serviceProviderId: this.number(0),
      tick: this.number(0),
      createdOn: this.attr(""),
      createdById: this.number(0),
      updatedOn: this.attr(""),
      updatedById: this.number(null),
      isFilling: this.boolean(true),
      emailConfigurationId: this.number(0),
      sendNotificationToSuperUser: this.boolean(false),
    };
  }

  static afterUpdate(_record: any) {}

  static beforeSelect(records: any) {
    return records.filter(
      (row: technicianGroupEntity) => row.technicianGroupId != 0,
    );
  }

  get emailConfigurationName() {
    if (this.emailConfigurationId != null && this.emailConfigurationId > 0) {
      let emailConfiguration = emailConfigurationEntity
        .query()
        .where("emailConfigurationId", this.emailConfigurationId)
        .first();
      if (emailConfiguration) {
        return emailConfiguration.serviceProviderFromEmailAddress;
      }
    }
    return "";
  }

  get groupNameWithEmail() {
    let name: string = this.name;
    if (this.emailConfigurationName != "") {
      name += ` (${this.emailConfigurationName})`;
    }
    return name;
  }

  get groupNameLowerCase() {
    return this.name.toLowerCase();
  }

  get customDate() {
    let customDate = DateTime.fromISO(this.createdOn, { zone: "utc" })
      .setZone(localTz())
      .setLocale(navigator.language)
      .toLocaleString(DateTime.DATE_MED);
    return customDate;
  }

  get technicianCount() {
    return technicianEntity
      .query()
      .where("statusId", 2)
      .where((tech: any) => {
        if (tech.subscribedGroupIds?.length) {
          return (tech.subscribedGroupIds as number[]).includes(
            this.technicianGroupId,
          );
        }
        return false;
      })
      .count();
  }

  get id() {
    return "@" + this.alias;
  }
}
